var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tax_data)?_c('InnerCardInfo',{ref:"inner",attrs:{"label":_vm.localStorage.translations.pages['setting-personal_area'].labels['nalogovyy-nomer'],"images":_vm.tax_data.image,"need-image-domain":"","data":[
    {
      name: _vm.localStorage.translations.pages['setting-personal_area'].labels['nalogovyy-nomer'],
      value: _vm.text || '-',
    },
  ],"editReady":_vm.editReady}},[_c('template',{slot:"edit_block"},[_vm._t("default")],2)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }